import { hasPermission } from './permission';

const sectionRedirectMap = [
  { section: 'dashboard', keys: ['dashboard_view'], path: '/cc/dashboard' },
  { section: 'jobs', keys: ['jobs_view', 'jobs_edit'], path: '/cc/jobs' },
  { section: 'invoices', keys: ['invoices_view', 'invoices_update'], path: '/cc/invoices' },
  { section: 'supervisors', keys: ['supervisors_view', 'supervisors_edit'], path: '/cc/supervisors' },
  { section: 'site users', keys: ['siteusers_view', 'siteusers_edit'], path: '/cc/siteusers' },
  { section: 'notes', keys: ['notes_view', 'notes_edit'], path: '/cc/notes' },
  { section: 'notifications', keys: ['notifications_view','notifications_manage'], path: '/cc/notifications' },
  { section: 'settings', keys: ['settings_view', 'settings_edit'], path: '/cc/settings' },
];

export const getFirstPermittedRoute = () => {
  for (const item of sectionRedirectMap) {
    if (hasPermission({ section: item.section, keys: item.keys })) {
      return item.path;
    }
  }
  return null;
};
